import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["groupIndex", "topLineType", "surface", "triggerType", "opened", "primitive", "topLine", "viewport", "triggerHoverPosition", "textLinkColor", "textLinkBorder"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { calculateRem } from '@vds-core/utilities';
import { Fonts } from '@vds-core/typography';
import { TextLink } from '@vds-core/buttons';
import { AccessibilityTokens } from '@vds-tokens/accessibility';
import { ColorTokens } from '@vds-tokens/color';
import { LayoutTokens } from '@vds-tokens/layout';
import { TypographyTokens } from '@vds-tokens/typography';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
var PADDING_DEFAULT_MOBILE = LayoutTokens.space['6X'].value; // 24px

var PADDING_DEFAULT_NON_MOBILE = LayoutTokens.space['8X'].value; // 32px

var _calcTextPaddingRight = function _calcTextPaddingRight(viewport, alwaysOpen, triggerType, triggerLinkWidth) {
  var isMobile = viewport === 'mobile';

  if (alwaysOpen) {
    return 0;
  } else {
    if (triggerType === 'icon') {
      return isMobile ? calculateRem(38) // 12px padding plus width of icon 26px
      : calculateRem(46); // 16px padding plus width of icon 30px
    }

    return isMobile ? calculateRem(triggerLinkWidth) : calculateRem(triggerLinkWidth);
  }
};

var _getCustomTitleSize = function _getCustomTitleSize(viewport, customChildrenTypography) {
  var isMobile = viewport === 'mobile';

  if (customChildrenTypography) {
    return TypographyTokens.fontsize.body[16].value;
  }

  return isMobile ? TypographyTokens.fontsize.title[16].value : TypographyTokens.fontsize.title[20].value;
};

var _getCustomTitleLetterSpacing = function _getCustomTitleLetterSpacing(viewport, customChildrenTypography) {
  if (customChildrenTypography) {
    return TypographyTokens.letterspacing.wide.value;
  }
};

var _getCustomTitleLineHeight = function _getCustomTitleLineHeight(viewport, customChildrenTypography) {
  var isMobile = viewport === 'mobile';

  if (customChildrenTypography) {
    return TypographyTokens.lineheight.body[20].value;
  }

  return isMobile ? TypographyTokens.lineheight.title[20].value : TypographyTokens.lineheight.title[24].value;
};

var _calcTextLinkSize = function _calcTextLinkSize(viewport) {
  var isMobile = viewport === 'mobile';
  return isMobile ? 'small' : 'large';
};

var _calcPaddingTop = function _calcPaddingTop(viewport) {
  var isMobile = viewport === 'mobile';
  return isMobile ? PADDING_DEFAULT_MOBILE : PADDING_DEFAULT_NON_MOBILE;
};

var _calcPaddingBottom = function _calcPaddingBottom(viewport, opened) {
  var isMobile = viewport === 'mobile';

  if (opened) {
    return isMobile ? LayoutTokens.space['4X'].value // 12px
    : LayoutTokens.space['6X'].value; // 16px
  }

  return isMobile ? PADDING_DEFAULT_MOBILE : PADDING_DEFAULT_NON_MOBILE;
};

var _calcToggleIconPositionHover = function _calcToggleIconPositionHover(viewport, opened) {
  var isMobile = viewport === 'mobile'; // move up + down 2px

  if (isMobile) {
    return opened ? calculateRem(22) : calculateRem(26);
  } else {
    return opened ? calculateRem(30) : calculateRem(34);
  }
};
/**
 * @param {*} viewport
 * @param {string} iconSize medium of 20px or large of 24px
 */


var _getIconSize = function _getIconSize(viewport, iconSize) {
  var isMobile = viewport === 'mobile';

  if (iconSize) {
    switch (iconSize) {
      case 'small':
        return 16;

      case 'large':
        return 24;

      case 'medium':
      default:
        return 20;
    }
  }

  return isMobile ? 20 : 24;
};

var _calcIconColor = function _calcIconColor(surface, clicked) {
  return clicked ? surface === 'dark' ? ColorTokens.interactive.active.ondark.value : ColorTokens.interactive.active.onlight.value : surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value;
};

var _calcTextLinkColor = function _calcTextLinkColor(surface, hovered, clicked) {
  var backgroundMode = surface === 'dark' ? 'ondark' : 'onlight';
  return clicked ? ColorTokens.interactive.active[backgroundMode].value : ColorTokens.elements.primary[backgroundMode].value;
};

var _calcTextLinkBorder = function _calcTextLinkBorder(surface, hovered, clicked) {
  var backgroundMode = surface === 'dark' ? 'ondark' : 'onlight';
  return clicked ? "".concat(calculateRem(2), " solid ").concat(ColorTokens.interactive.active[backgroundMode].value) : hovered ? "".concat(calculateRem(2), " solid ").concat(ColorTokens.elements.primary[backgroundMode].value) : "".concat(calculateRem(1), " solid ").concat(ColorTokens.elements.primary[backgroundMode].value);
};

var propTypes = {
  /**
   * When true, the header will take on the properties of an opened drawer.
   * @ignore
   */
  opened: PropTypes.bool,

  /**
   * Components to render inside of the AccordionHeader. Can be any node but it is recommended to use provided components AccordionTitle and AccordionSubTitle.
   */
  children: PropTypes.node.isRequired,

  /**
   * If provided, this function will be called if this AccordionHeader is clicked. This will return (event, opened state of the accordion item).
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onTrigger: PropTypes.func,

  /**
   * @ignore
   */
  groupIndex: PropTypes.number,

  /**
   * @ignore
   */
  groupId: PropTypes.string,

  /**
   * @ignore
   */
  sticky: PropTypes.bool,

  /**
   * @ignore
   */
  style: PropTypes.object,
  // <- Used for react-sticky

  /**
   * @ignore
   */
  testMode: PropTypes.bool,

  /**
   *	Header action item will be set either an icon or link based on string passed.
   */
  triggerType: PropTypes.oneOf(['icon', 'link']),

  /**
   * If provided, will render the label for text link trigger in the closed state
   */
  openAccordionTriggerLabel: PropTypes.string,

  /**
   * If provided, will render the label for text link trigger in the opened state
   */
  closeAccordionTriggerLabel: PropTypes.string,

  /**
   * @ignore
   * When true, the drawer will remain opened and not be able to close.
   * Prop will be passed from AccordionItem
   */
  alwaysOpen: PropTypes.bool,

  /**
   * Set the styling of the component to the desktop, tablet, or mobile size based on passed prop. Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['desktop', 'mobile', 'tablet']),

  /**
   * Passes a new primitive to the AccordionHeader Component
   */
  primitive: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div']),

  /**
   * Aria label used for accordion header.
   */
  ariaLabel: PropTypes.string,

  /**
   * @ignore
   * Optional TextLink component for 1.0. Defaults to TextLink 3.0
   */
  TextLinkComponent: PropTypes.func,

  /**
   * @ignore
   * Small for 1.0
   * Defaults to small mobile and large desktop for 3.0
   */
  calcTextLinkSize: PropTypes.func,

  /**
   * @ignore
   * focusRing border. Defaults to true for 3.0
   */
  focusRingBorderRadius: PropTypes.bool,

  /**
   * @ignore
   * When passing in children in children wrapper, will default to Title configs for 3.0
   */
  customChildrenTypography: PropTypes.bool,

  /**
   * @ignore
   * If passes in custom child in header, bold will turn the custom child passed in bold
   */
  bold: PropTypes.bool,

  /**
   * @ignore
   * If enabled, don't render border-top used for 1.0
   */
  topLine: PropTypes.bool,

  /**
   * @ignore
   * Function to render padding top 8px for 1.0.
   * Else 32px for desktop/tablet and 24px for mobile
   */
  calcPaddingTop: PropTypes.func,

  /**
   * @ignore
   * Function to render padding bottom
   */
  calcPaddingBottom: PropTypes.func,

  /**
   * @ignore
   * If enabled, will render 60px padding right for ChildrenWrapper.
   */
  calcTextPaddingRight: PropTypes.func,

  /**
   * @ignore
   * If enabled, render top position of toggle icon wrapper to 8.
   * Defaults to 24 (mobile) and 32 (desktop/tablet) for 3.0
   */
  calcToggleIconPositionHover: PropTypes.func,

  /**
   * @ignore
   * if provided, toggle icon transition time is 350ms for 1.0. Defaults to 330ms for 3.0
   */
  toggleIconTransitionTime: PropTypes.string,

  /**
   * @ignore
   */
  fixedTextLinkLabel: PropTypes.bool,

  /**
   * @ignore
   * Size for icon. Defaults to large for 3.0 desktop/tablet and medium for 1.0
   */
  iconSize: PropTypes.oneOf(['small', 'large', 'medium']),

  /**
   * @ignore
   * if provided, toggle icon weight will be bold
   */
  iconBold: PropTypes.bool,

  /**
   * @ignore
   * Function to calculate icon color when clicked, if any
   */
  calcIconColor: PropTypes.func,

  /**
   * @ignore
   * Function to calculate textLink color.
   */
  calcTextLinkColor: PropTypes.func,

  /**
   * @ignore
   * Function to calculate textLink bottom border.
   */
  calcTextLinkBorder: PropTypes.func,

  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * @ignore
   */
  analyticsTrack: PropTypes.string,

  /**
   * @ignore
   */
  track: PropTypes.string,

  /**
   * @ignore
   */
  trackIgnore: PropTypes.string,

  /**
   * @ignore
   */
  clickStream: PropTypes.string,

  /**
   * @ignore
   */
  cta: PropTypes.string,

  /**
   * @ignore
   */
  level: PropTypes.string,

  /**
   * @ignore
   */
  position: PropTypes.string,

  /**
   * @ignore
   */
  dataTrack: PropTypes.string
};
var defaultProps = {
  opened: false,
  onClick: null,
  onTrigger: function onTrigger() {},
  groupIndex: 1,
  groupId: null,
  surface: 'light',
  sticky: false,
  style: {},
  testMode: false,
  triggerType: 'icon',
  alwaysOpen: false,
  viewport: 'desktop',
  //1.0
  primitive: 'div',
  ariaLabel: undefined,
  //3.0
  TextLinkComponent: TextLink,
  focusRingBorderRadius: true,
  primaryColor: false,
  bold: false,
  topLine: true,
  toggleIconPositionSmall: false,
  toggleIconTransitionTime: '330ms',
  closeAccordionTriggerLabel: 'Cancel',
  openAccordionTriggerLabel: 'Change',
  fixedTextLinkLabel: false,
  iconBold: false,
  calcPaddingTop: _calcPaddingTop,
  calcPaddingBottom: _calcPaddingBottom,
  calcTextLinkSize: _calcTextLinkSize,
  calcTextPaddingRight: _calcTextPaddingRight,
  calcToggleIconPositionHover: _calcToggleIconPositionHover,
  calcIconColor: _calcIconColor,
  calcTextLinkColor: _calcTextLinkColor,
  calcTextLinkBorder: _calcTextLinkBorder
};
var TriggerLinkWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "TriggerLinkWrapper",
  componentId: "VDS__sc-19osi3m-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  > * {\n    outline: none;\n  }\n  padding-left: ", ";\n"])), function (_ref) {
  var triggerType = _ref.triggerType,
      viewport = _ref.viewport,
      fixedTextLinkLabel = _ref.fixedTextLinkLabel;
  return triggerType === 'link' && !fixedTextLinkLabel && "\n  max-width: ".concat(viewport === 'mobile' ? '50%' : '25%', ";\n  position: absolute;\n  right: 3px; // To avoid cut off\n  top:  ").concat(calculateRem(32), ";\n  span:last-child {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: text-top;\n  }\n  ");
}, calculateRem(16));
var TriggerIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TriggerIconWrapper",
  componentId: "VDS__sc-19osi3m-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 1;\n  position: absolute;\n  right: 0;\n  > * {\n    outline: none;\n  }\n  transition: ", ";\n  height: ", ";\n  top: ", ";\n\n  ", ";\n  &:focus {\n    outline: none;\n  }\n  svg {\n    overflow: visible; //safari cuts off the border if overflow is not visible\n  }\n"])), function (_ref2) {
  var toggleIconTransitionTime = _ref2.toggleIconTransitionTime;
  return "top ".concat(toggleIconTransitionTime, " cubic-bezier(0.22, 0.61, 0.36, 1);");
}, calculateRem(20), function (_ref3) {
  var triggerPosition = _ref3.triggerPosition;
  return triggerPosition;
}, function (_ref4) {
  var opened = _ref4.opened,
      triggerType = _ref4.triggerType,
      toggleIconTransitionTime = _ref4.toggleIconTransitionTime;
  return triggerType === 'icon' && "\n    justify-content: ".concat(opened ? 'flex-start' : 'flex-end', ";\n    transform: rotate(").concat(opened ? "-180deg" : "0deg", ");\n    transition: transform ").concat(toggleIconTransitionTime, " cubic-bezier(0.22, 0.61, 0.36, 1), top ").concat(toggleIconTransitionTime, " cubic-bezier(0.22,0.61,0.36,1); \n  ");
});
var StyledAccordionButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledAccordionButton",
  componentId: "VDS__sc-19osi3m-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  text-align: left;\n  width: 100%;\n  margin-bottom: 0;\n  padding: 0;\n  background: none;\n  border: 0;\n  overflow: visible;\n\n  padding-right: ", ";\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  overflow: hidden;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  &:active,\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n  ", ";\n\n  ", ";\n"])), function (_ref5) {
  var paddingRight = _ref5.paddingRight;
  return paddingRight;
}, function (_ref6) {
  var surface = _ref6.surface;
  return surface === 'dark' ? ColorTokens.background.primary.dark.value : ColorTokens.background.primary.light.value;
}, function (_ref7) {
  var surface = _ref7.surface;
  return surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value;
}, function (_ref8) {
  var alwaysOpen = _ref8.alwaysOpen;
  return alwaysOpen ? 'default' : 'pointer';
}, Fonts.VerizonNHGeDS, function (_ref9) {
  var viewport = _ref9.viewport,
      customChildrenTypography = _ref9.customChildrenTypography;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    letter-spacing: ", ";\n    min-height: ", ";\n    line-height: ", ";\n  "])), _getCustomTitleSize(viewport, customChildrenTypography), _getCustomTitleLetterSpacing(viewport, customChildrenTypography), _getCustomTitleLineHeight(viewport, customChildrenTypography), _getCustomTitleLineHeight(viewport, customChildrenTypography));
}, function (_ref10) {
  var bold = _ref10.bold;
  return bold ? TypographyTokens.fontweight.bold.value : TypographyTokens.fontweight.regular.value;
}, function (_ref11) {
  var paddingTop = _ref11.paddingTop,
      paddingBottom = _ref11.paddingBottom;
  return "\n  padding-top: ".concat(paddingTop, ";\n  padding-bottom: ").concat(paddingBottom, ";\n  transition: padding-bottom 350ms ease;\n  ");
}, function (_ref12) {
  var surface = _ref12.surface,
      focusRingBorderRadius = _ref12.focusRingBorderRadius;
  return "\n    &::-moz-focus-inner, \n    ::-moz-focus-inner {\n      border: 0;\n    }\n    &:active, &:hover {\n      .toggleIconWrapper > div {\n        border-color: transparent !important;\n      }\n    }\n    &:focus {\n      outline: none;\n      &:not(:hover) {\n        a {\n          &:after {\n            content: \"\";\n            position: absolute;\n            top: ".concat(calculateRem(-3), ";\n            bottom: ").concat(calculateRem(-4), ";\n            right: ").concat(calculateRem(-3), ";\n            left: ").concat(calculateRem(-3), ";\n            box-sizing: border-box;\n            border: ").concat(surface === 'dark' ? "".concat(calculateRem(AccessibilityTokens.width.focusring.value), " ").concat(AccessibilityTokens.borderstyle.focusring.value, " ").concat(AccessibilityTokens.color.focusring.ondark.value) : "".concat(calculateRem(AccessibilityTokens.width.focusring.value), " ").concat(AccessibilityTokens.borderstyle.focusring.value, " ").concat(AccessibilityTokens.color.focusring.onlight.value), ";\n            border-radius: ").concat(focusRingBorderRadius ? calculateRem(2) : 0, ";\n        }\n      }\n    }\n    &:focus {\n      .toggleIconWrapper > div {\n        box-sizing: border-box;\n        border: ").concat(surface === 'dark' ? "".concat(calculateRem(AccessibilityTokens.width.focusring.value), " ").concat(AccessibilityTokens.borderstyle.focusring.value, " ").concat(AccessibilityTokens.color.focusring.ondark.value) : "".concat(calculateRem(AccessibilityTokens.width.focusring.value), " ").concat(AccessibilityTokens.borderstyle.focusring.value, " ").concat(AccessibilityTokens.color.focusring.onlight.value), ";\n        border-radius: ").concat(focusRingBorderRadius ? calculateRem(2) : 0, ";\n    }\n  ");
}); //margin 0 and fontsize inherit are there to ignore defualt styling of h tags

var WrapperDiv = /*#__PURE__*/styled(function (_ref13) {
  var groupIndex = _ref13.groupIndex,
      topLineType = _ref13.topLineType,
      surface = _ref13.surface,
      triggerType = _ref13.triggerType,
      opened = _ref13.opened,
      primitive = _ref13.primitive,
      topLine = _ref13.topLine,
      viewport = _ref13.viewport,
      triggerHoverPosition = _ref13.triggerHoverPosition,
      textLinkColor = _ref13.textLinkColor,
      textLinkBorder = _ref13.textLinkBorder,
      rest = _objectWithoutProperties(_ref13, _excluded);

  return /*#__PURE__*/React.createElement(primitive, rest);
}).withConfig({
  displayName: "WrapperDiv",
  componentId: "VDS__sc-19osi3m-3"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: inherit;\n  background-color: ", ";\n  ", "\n  padding-top: 0;\n  position: relative;\n  width: 100%;\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref14) {
  var surface = _ref14.surface;
  return surface === 'dark' ? ColorTokens.background.primary.dark.value : ColorTokens.background.primary.light.value;
}, function (_ref15) {
  var topLine = _ref15.topLine,
      groupIndex = _ref15.groupIndex,
      topLineType = _ref15.topLineType;
  return !topLine && topLineType && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      border-top: ", "\n        solid\n        ", ";\n    "])), calculateRem(!groupIndex && topLineType === 'heavy' ? 4 : 1), function (_ref16) {
    var surface = _ref16.surface;
    return surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value;
  });
}, function (_ref17) {
  var groupIndex = _ref17.groupIndex,
      topLine = _ref17.topLine;
  return groupIndex && !topLine && "\n    border-top: none;\n  ";
}, function (_ref18) {
  var triggerType = _ref18.triggerType,
      textLinkColor = _ref18.textLinkColor,
      textLinkBorder = _ref18.textLinkBorder;
  return triggerType === 'link' && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      a {\n        color: ", ";\n        border-bottom: ", ";\n      }\n    "])), textLinkColor, textLinkBorder);
}, function (_ref19) {
  var triggerType = _ref19.triggerType,
      triggerHoverPosition = _ref19.triggerHoverPosition;
  return triggerType !== 'link' && "\n      &:hover .toggleIconWrapper {\n          cursor: pointer;\n          top: ".concat(triggerHoverPosition, ";\n      }\n  ");
});
var TriggerIconSVGWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "TriggerIconSVGWrapper",
  componentId: "VDS__sc-19osi3m-4"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  pointer-events: none;\n  ", ";\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n"])), function (_ref20) {
  var iconColor = _ref20.iconColor;
  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    svg {\n      polygon,\n      path {\n        fill: ", ";\n      }\n    }\n  "])), iconColor);
}, function (_ref21) {
  var iconSize = _ref21.iconSize;
  return calculateRem(iconSize);
}, function (_ref22) {
  var iconSize = _ref22.iconSize;
  return calculateRem(iconSize);
}, function (_ref23) {
  var iconSize = _ref23.iconSize;
  return calculateRem(iconSize);
}, function (_ref24) {
  var iconSize = _ref24.iconSize;
  return calculateRem(iconSize);
});

var AccordionHeader = /*#__PURE__*/function (_Component) {
  _inherits(AccordionHeader, _Component);

  var _super = _createSuper(AccordionHeader);

  function AccordionHeader(props) {
    var _this;

    _classCallCheck(this, AccordionHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      typeof window !== 'undefined' && window.addEventListener('resize', _this.getTriggerLinkWidth);

      _this.getTriggerLinkWidth();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      typeof window !== 'undefined' && window.removeEventListener('resize', _this.getTriggerLinkWidth);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var opened = prevProps.opened;
      var nextState = {};

      if (opened !== _this.props.opened) {
        _this.getTriggerLinkWidth();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getTriggerLinkWidth", function () {
      if (_this.props.triggerType === 'link' && _this.triggerRef) {
        _this.setState({
          triggerLinkWidth: _this.triggerRef.getBoundingClientRect().width
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isFirefox", function () {
      return typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }());

    _defineProperty(_assertThisInitialized(_this), "_clicked", function (e) {
      var _document$getElementB;

      var groupId = _this.props.groupId;
      var hovered = _this.state.hovered;
      var focusWrapper = (_document$getElementB = document.getElementById("accordionHeader_".concat(groupId))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.querySelector('svg');

      if (_this.isFirefox && hovered) {
        //JAWS reads key events as mouse events, so if hovered that means this is a real click
        focusWrapper.style.border = 'none'; // removing border is better than blurring
      }

      _this.setState({
        clicked: !_this.state.clicked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_clearStates", function (e) {
      _this.setState({
        clicked: false,
        hovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getTriggerLabel", function () {
      var _this$props = _this.props,
          openAccordionTriggerLabel = _this$props.openAccordionTriggerLabel,
          closeAccordionTriggerLabel = _this$props.closeAccordionTriggerLabel,
          opened = _this$props.opened;

      if (opened) {
        return closeAccordionTriggerLabel || 'Cancel';
      } else {
        return openAccordionTriggerLabel || 'Change';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "refPath", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this), "_renderTriggerTypeIcon", function () {
      var _this$props2 = _this.props,
          iconBold = _this$props2.iconBold,
          calcIconColor = _this$props2.calcIconColor,
          surface = _this$props2.surface,
          viewport = _this$props2.viewport,
          iconSize = _this$props2.iconSize;
      var _this$state = _this.state,
          opened = _this$state.opened,
          clicked = _this$state.clicked;
      return /*#__PURE__*/React.createElement(TriggerIconSVGWrapper, {
        tabIndex: -1,
        "aria-label": opened ? 'expanded' : 'collapsed',
        "aria-hidden": "true",
        iconColor: calcIconColor(surface, clicked),
        iconSize: _getIconSize(viewport, iconSize)
      }, iconBold ? /*#__PURE__*/React.createElement("svg", {
        id: "ad92a828-c26e-4510-a885-e9f50ae4a911",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }, /*#__PURE__*/React.createElement("title", null, "caret-down"), /*#__PURE__*/React.createElement("path", {
        d: "M12,17.79,2,7.64,3.41,6.21,12,14.93l8.56-8.65L22,7.7Z"
      })) : /*#__PURE__*/React.createElement("svg", {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 21.6 21.6"
      }, /*#__PURE__*/React.createElement("polygon", {
        points: "10.8 15.71 1.8 6.71 2.62 5.89 10.8 14.07 18.98 5.89 19.8 6.71 10.8 15.71"
      })));
    });

    _this.state = {
      clicked: false,
      hovered: false,
      triggerLinkWidth: typeof window !== 'undefined' && window.innerWidth / 4
    };
    return _this;
  }

  _createClass(AccordionHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var groupId = this.props.groupId;
      this.accordionHeaderId = "accordionHeader_".concat(groupId);
      this.accordionAriaControlsId = "accordionDetail_".concat(groupId);
    }
  }, {
    key: "render",
    value: function render() {
      var _document$getElementB2,
          _this2 = this;

      var _this$props3 = this.props,
          opened = _this$props3.opened,
          children = _this$props3.children,
          onClick = _this$props3.onClick,
          groupIndex = _this$props3.groupIndex,
          groupId = _this$props3.groupId,
          surface = _this$props3.surface,
          sticky = _this$props3.sticky,
          style = _this$props3.style,
          testMode = _this$props3.testMode,
          viewport = _this$props3.viewport,
          triggerType = _this$props3.triggerType,
          alwaysOpen = _this$props3.alwaysOpen,
          onTrigger = _this$props3.onTrigger,
          analyticsTrack = _this$props3.analyticsTrack,
          track = _this$props3.track,
          trackIgnore = _this$props3.trackIgnore,
          clickStream = _this$props3.clickStream,
          cta = _this$props3.cta,
          level = _this$props3.level,
          position = _this$props3.position,
          dataTrack = _this$props3.dataTrack,
          topLineType = _this$props3.topLineType,
          primitive = _this$props3.primitive,
          ariaLabel = _this$props3.ariaLabel,
          TextLinkComponent = _this$props3.TextLinkComponent,
          calcTextLinkSize = _this$props3.calcTextLinkSize,
          focusRingBorderRadius = _this$props3.focusRingBorderRadius,
          bold = _this$props3.bold,
          customChildrenTypography = _this$props3.customChildrenTypography,
          calcPaddingBottom = _this$props3.calcPaddingBottom,
          calcPaddingTop = _this$props3.calcPaddingTop,
          calcTextPaddingRight = _this$props3.calcTextPaddingRight,
          calcToggleIconPositionHover = _this$props3.calcToggleIconPositionHover,
          toggleIconTransitionTime = _this$props3.toggleIconTransitionTime,
          fixedTextLinkLabel = _this$props3.fixedTextLinkLabel,
          iconSize = _this$props3.iconSize,
          iconBold = _this$props3.iconBold,
          calcIconColor = _this$props3.calcIconColor,
          calcTextLinkColor = _this$props3.calcTextLinkColor,
          calcTextLinkBorder = _this$props3.calcTextLinkBorder;
      var focusWrapper = typeof document !== 'undefined' && ((_document$getElementB2 = document.getElementById("accordionHeader_".concat(groupId))) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.querySelector('svg'));

      var _onClick = function _onClick(e) {
        onClick && onClick(e);
        onTrigger && onTrigger(e);

        _this2.getTriggerLinkWidth();
      };

      var _onFocus = function _onFocus(e) {
        //set styles for firefox because we cant use tabindex -1
        if (_this2.isFirefox) {
          focusWrapper.style.border = "\n          ".concat(AccessibilityTokens.width.focusring.value, "\n          ").concat(AccessibilityTokens.borderstyle.focusring.value, "\n          ").concat(surface === 'dark' ? AccessibilityTokens.color.focusring.ondark.value : AccessibilityTokens.color.focusring.onlight.value);

          if (focusRingBorderRadius) {
            focusWrapper.style.borderRadius = calculateRem(2);
          }
        }
      };

      var _onBlur = function _onBlur(e) {
        return _this2.isFirefox ? focusWrapper.style.border = 'none' : null;
      };

      var _onHover = function _onHover(e) {
        return _this2.setState({
          hovered: true
        });
      };

      var TriggerComponentWrapper = triggerType === 'link' && !fixedTextLinkLabel ? TriggerLinkWrapper : TriggerIconWrapper;
      var triggerLinkWidth = this.state.triggerLinkWidth;
      return /*#__PURE__*/React.createElement(WrapperDiv, {
        "data-testid": sticky && testMode ? "sticky_".concat(groupId) : undefined,
        id: this.accordionHeaderId,
        groupIndex: groupIndex,
        surface: surface,
        triggerType: triggerType,
        opened: opened,
        topLineType: topLineType,
        primitive: primitive,
        triggerHoverPosition: calcToggleIconPositionHover(viewport, opened),
        viewport: viewport,
        textLinkColor: calcTextLinkColor(surface, this.state.hovered, this.state.clicked),
        textLinkBorder: calcTextLinkBorder(surface, this.state.hovered, this.state.clicked)
      }, /*#__PURE__*/React.createElement(StyledAccordionButton, {
        className: "accordionButton",
        focusRingBorderRadius: focusRingBorderRadius,
        "aria-expanded": opened,
        "aria-controls": this.accordionAriaControlsId,
        onClick: _onClick,
        type: "button",
        tabIndex: 0,
        onFocus: _onFocus,
        onBlur: _onBlur,
        surface: surface,
        onMouseDown: this._clicked,
        onMouseUp: this._clicked,
        onMouseEnter: _onHover,
        onMouseLeave: this._clearStates,
        "aria-label": ariaLabel,
        "data-clickstream": clickStream,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-track-ignore": trackIgnore,
        "data-sitecat-datatrack": dataTrack,
        "data-sitecat-position": position,
        "data-sitecat-level": level,
        "data-sitecat-cta": cta,
        triggerType: triggerType,
        fixedTextLinkLabel: fixedTextLinkLabel,
        alwaysOpen: alwaysOpen,
        viewport: viewport,
        bold: bold,
        customChildrenTypography: customChildrenTypography,
        paddingTop: calcPaddingTop(viewport),
        paddingBottom: calcPaddingBottom(viewport, opened || alwaysOpen),
        paddingRight: calcTextPaddingRight(viewport, alwaysOpen, triggerType, triggerLinkWidth)
      }, React.Children.map(children, function (child, index) {
        if (child && child.type && child.type.displayName === 'AccordionTitle') {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
            surface: surface,
            viewport: viewport,
            bold: bold
          }));
        } else if (child && child.type && child.type.displayName === 'AccordionSubTitle') {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
            surface: surface,
            viewport: viewport
          }));
        } else {
          return child;
        }
      }), !alwaysOpen && /*#__PURE__*/React.createElement(TriggerComponentWrapper, _extends({
        className: "toggleIconWrapper",
        surface: surface,
        tabIndex: -1,
        opened: opened,
        triggerType: triggerType,
        "aria-hidden": triggerType === 'icon' && true,
        viewport: viewport,
        fixedTextLinkLabel: fixedTextLinkLabel,
        toggleIconTransitionTime: toggleIconTransitionTime,
        triggerPosition: calcPaddingTop(viewport) // align with overall component padding-top

      }, _defineProperty({}, this.refPath, function (elem) {
        return _this2.triggerRef = elem;
      })), triggerType === 'link' && /*#__PURE__*/React.createElement(TextLinkComponent, {
        tabIndex: -1,
        type: "standAlone",
        size: calcTextLinkSize(viewport),
        activeState: this.state.clicked,
        surface: surface
      }, this._getTriggerLabel()), triggerType === 'icon' && this._renderTriggerTypeIcon())));
    }
  }]);

  return AccordionHeader;
}(Component);

_defineProperty(AccordionHeader, "componentType", 'AccordionHeader');

AccordionHeader.defaultProps = defaultProps;
AccordionHeader.propTypes = propTypes;
export default AccordionHeader;